module.exports = __webpack_public_path__ + "media/images/emotions/sebastiao-joy-c549afecdaa8e3724ff01ff409a49c78.svg";